module.exports = __webpack_public_path__ + "static/media/tiger-900.e8fc07c3.jpg";